const getNavTree = translate => [
  {
    route: "/majutus",
    title: translate("yld.navigatsioon.majutus"),
    subPages: [
      { route: "/majutus/motell", title: translate("yld.navigatsioon.motell") },
      {
        route: "/majutus/ridaelamud",
        title: translate("yld.navigatsioon.ridaelamud")
      },
      {
        route: "/majutus/saunamajad",
        title: translate("yld.navigatsioon.saunamajad")
      },
      {
        route: "/majutus/palkmajad",
        title: translate("yld.navigatsioon.palkmajad")
      },
      {
        route: "/majutus/kampingud",
        title: translate("yld.navigatsioon.kampingud")
      },
      {
        route: "/majutus/karavan",
        title: translate("yld.navigatsioon.karavan")
      }
    ]
  },
  {
    route: "/yritused",
    title: translate("yld.navigatsioon.yritused"),
    subPages: [
      {
        route: "/yritused/suvepaevad",
        title: translate("yld.navigatsioon.suvepaevad")
      },
      {
        route: "/yritused/synnipaevad",
        title: translate("yld.navigatsioon.synnipaevad")
      },
      {
        route: "/yritused/pulmad",
        title: translate("yld.navigatsioon.pulmad")
      },
      {
        route: "/yritused/seminarid",
        title: translate("yld.navigatsioon.seminarid")
      }
    ]
  },
  { route: "/toitlustus", title: translate("yld.navigatsioon.toitlustus") },
  { route: "/sadam", title: translate("yld.navigatsioon.sadam") },
  {
    route: "/tegevused",
    title: translate("yld.navigatsioon.tegevused"),
    subPages: [
      {
        route: "/tegevused/windsurf",
        title: translate("yld.navigatsioon.windsurf")
      },
      { route: "/tegevused/sup", title: translate("yld.navigatsioon.sup") },
      {
        route: "/tegevused/pallimangud",
        title: translate("yld.navigatsioon.pallimangud")
      },
      {
        route: "/tegevused/discgolf",
        title: translate("yld.navigatsioon.discgolf")
      },
      {
        route: "/tegevused/piljard",
        title: translate("yld.navigatsioon.piljard")
      },
      {
        route: "/tegevused/saunad",
        title: translate("yld.navigatsioon.saunad")
      },
      {
        route: "/tegevused/paadirent",
        title: translate("yld.navigatsioon.paadirent")
      },
      {
        route: "/tegevused/jalgrattarent",
        title: translate("yld.navigatsioon.jalgrattarent")
      },
      {
        route: "/tegevused/jahindus",
        title: translate("yld.navigatsioon.jahindus")
      },
      {
        route: "/tegevused/koostoopartnerid",
        title: translate("yld.navigatsioon.koostoopartnerid")
      }
    ]
  },
  { route: "/galerii", title: translate("yld.navigatsioon.galerii") },
  { route: "/kontakt", title: translate("yld.navigatsioon.kontakt") },
  { route: "/covid-info", title: translate("yld.navigatsioon.covid") }
];

export default getNavTree;
